import React, { useState, useRef, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import AuthPhone from "../models/firebase/AuthPhone";
import {
  createRecaptchaVerifier,
  getPhoneAuthErrorTranslationKey,
} from "../models/firebase";
import { Namespaces } from "../components/LanguageSelector";

function Login({ onLogin }) {
  const [authPhone, setAuthPhone] = useState(null);
  const [wrongCode, setWrongCode] = useState(false);
  const [authErrorKey, setAuthErrorKey] = useState(null);
  const phoneInput = useRef(null);
  const codeInput = useRef(null);
  const captchaContainer = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    window.recaptchaVerifier = createRecaptchaVerifier(
      captchaContainer.current
    );
    window.recaptchaVerifier.render().then(function (widgetId) {
      window.recaptchaWidgetId = widgetId;
    });
  }, []);

  const enterCode = useCallback(async () => {
    setWrongCode(false);
    try {
      await authPhone.enterCode(codeInput.current.value);
    } catch (e) {
      setWrongCode(true);
    }
  }, [authPhone]);

  const onPhoneEnter = async (phone) => {
    setAuthErrorKey(null);

    const authPhone = new AuthPhone(phone);

    authPhone.once("code-sent", () => setAuthPhone(authPhone));

    try {
      await authPhone.getCode();
    } catch (e) {
      return setAuthErrorKey(getPhoneAuthErrorTranslationKey(e));
    }

    if (onLogin) {
      authPhone.once("auth-success", onLogin);
    }
  };
  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 mt-2 mb-4">
          <div className="bg-white m-1 p-3 shadow-sm">
            <p className="text-center h4">
              {t(`${Namespaces.login}.login_title`)}
            </p>
            <p>
              {t(`${Namespaces.login}.login_subtitle`)}
            </p>
          </div>
        </div>

        <div className="col-12">
          <div className="bg-white m-1 p-3 shadow-sm">
            <p className="text-center small text-muted">
              {t(`${Namespaces.login}.login_prompt`)}
            </p>
            <div>
              <div className="input-group mb-3">
                <input
                  type="tel"
                  className="form-control"
                  name="phone"
                  placeholder={t(`${Namespaces.login}.phone_number`)}
                  aria-label={t(`${Namespaces.login}.phone_number`)}
                  ref={phoneInput}
                />
              </div>
              {authPhone ? (
                <div className="input-group mb-3">
                  <input
                    type="tel"
                    className="form-control"
                    name="number"
                    placeholder={t(`${Namespaces.login}.verification_code`)}
                    aria-label={t(`${Namespaces.login}.verification_code`)}
                    ref={codeInput}
                  />
                </div>
              ) : null}
              {wrongCode ? (
                <div className="text-danger text-center text-size-secondary mb-3">
                  {t(`${Namespaces.login}.verification_failed`)}
                </div>
              ) : null}
              {authErrorKey ? (
                <div className="text-danger text-center text-size-secondary mb-3">
                  {t(`${Namespaces.login}.${authErrorKey}`)}
                </div>
              ) : null}
              <div ref={captchaContainer}></div>
              <div className="text-center">
                {authPhone ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={enterCode}
                  >
                    {t(`${Namespaces.login}.login`)}
                  </button>
                ) : (
                  <button
                    type="button"
                    id="login-button"
                    className="btn btn-primary"
                    onClick={() => onPhoneEnter(phoneInput.current.value)}
                  >
                    {t(`${Namespaces.login}.get_verification_code`)}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
